const oficialmicrositio = {
    ObtenLosMenusYSubmenusDeMicrositio: 'SICPO/Micrositio/GetMenuMicrositio',
    ObtenIdMenuSubmenu:'SICPO/Micrositio/GetIdMenuSubmenu',
    ObtenPaginaDeMicrositio:'SICPO/Micrositio/GetPaginaMicrositio',
    ObtenComunicadosMicrositios:'SICPO/Micrositio/GetComunicadosMicrositios',
    AltaDeContenidoMicrositio:'SICPO/AltaDeContenido/AltaDeContenidoMicrositio',
    ValidarUsuario:'SICPO/Micrositio/AutenticarPaginaRestringida',
}

export default oficialmicrositio;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/micrositioweb/oficialmicrositio/oficialmicrositio.js
// module id = null
// module chunks = 